import React from "react";
import { Page, BlockTitle, List, ListItem } from "framework7-react";
import { buildLocationNavItems, MobileNavList } from "modules/1_layout/mobile/AppSidebar/helpers";

export const StoreSidebar = (props) => {
  const [, forceRerender] = React.useState();
  const { mobileCustomForms, mobileMenus, custom_forms } = props;
  const storeNavItems = buildLocationNavItems("store", mobileCustomForms, mobileMenus, custom_forms);

  return (
    <Page>
      <BlockTitle>Store Menu</BlockTitle>
      <List>
        <ListItem title="Bookout Items" link="/store/bookout_items" panelClose onClick={forceRerender} />
        <ListItem title="Overalls" link="/store/overalls" panelClose onClick={forceRerender} />
      </List>
      <MobileNavList items={storeNavItems} />
      <List>
        <ListItem title="Back to Lion" link="/" panelClose onClick={forceRerender} />
      </List>
    </Page>
  );
};

export default StoreSidebar;
